import React, { useState } from "react"
import LotsRow from "./LotsRow"
import iconAdd from "./../../../../Assets/Img/iconAdd2Edit.svg"

export default function ProductInTagRow({
	product,
	tagProducts = [],
	selectedProducts = [],
	item,
	i,
	currentOrderSubitem,
	handleAddOrRemoveItems,
	}) {
	const [openInfo, setOpenInfo] = useState(false)

	const productId = product?._id
	const productName = product?.name || "-"
	const productQuantity = product?.quantity || 0

	const selectedProduct = selectedProducts.find(
		selectedProduct => selectedProduct?.data?._id === productId
	)

	const unitTypeName = product?.unitType?.name || product?.measure?.name || "-"
	const weightOrVolume = product?.weightOrVolume
	const lots = product?.lots || []

	const currentQuantity = currentOrderSubitem?.currentQuantity || productQuantity
	const quantityToSend = currentOrderSubitem?.quantityToSend || 0

	return (
		<>
		<tr
			className={
			i + 1 === tagProducts.length && !openInfo
				? "border-bottom-table"
				: ""
			}
		>
			<td className="text-start">
			{productName}
			</td>

			<td className="quantity-td">
				<input
					type="number"
					min="1"
					value={
						selectedProducts.find(
						selectedProduct => selectedProduct?.data?._id === product?._id
						)?.quantityRequested || ""
					}
					onChange={e =>
						handleAddOrRemoveItems(
						{
							data: product,
							parentTag: item,
						},
						e.target.value
						)
					}
					className="
						tw-w-[100px]
						tw-min-w-[100px]
						tw-h-[24px]
						tw-inline-block
						tw-rounded-md
						tw-border
						tw-border-gray-400
						tw-bg-white
						tw-px-2
						tw-py-1
						tw-text-sm
						tw-text-gray-900
						tw-outline-none
						focus:tw-border-[#42999b]
						focus:tw-ring-2
						focus:tw-ring-[#42999b]/20
					"
				/>			
			</td>

			<td className={currentQuantity - quantityToSend < 0 ? "text-red" : ""}>
			{`${productQuantity} ud/s.`}
			</td>

			<td>
			{`${unitTypeName}${weightOrVolume ? ` (${weightOrVolume} c/u)` : ""}`}
			</td>

			<td>
			<button
				type="button"
				className="lotButton"
				onClick={() => setOpenInfo(prev => !prev)}
			>
				<img
				src={iconAdd}
				alt="Icono ver más"
				/>
			</button>
			</td>
		</tr>

		{openInfo && <LotsRow lots={lots} />}
		</>
	)
}